import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=ff596cb6&scoped=true"
import script from "./NewTemplate.vue?vue&type=script&lang=js"
export * from "./NewTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewTemplate.vue?vue&type=style&index=0&id=ff596cb6&prod&lang=scss&scoped=true"
import style1 from "./NewTemplate.vue?vue&type=style&index=1&id=ff596cb6&prod&lang=scss"
import style2 from "./NewTemplate.vue?vue&type=style&index=2&id=ff596cb6&prod&lang=scss"
import style3 from "./NewTemplate.vue?vue&type=style&index=3&id=ff596cb6&prod&lang=scss&scoped=true"
import style4 from "./NewTemplate.vue?vue&type=style&index=4&id=ff596cb6&prod&lang=scss&scoped=true"
import style5 from "./NewTemplate.vue?vue&type=style&index=5&id=ff596cb6&prod&lang=scss"
import style6 from "./NewTemplate.vue?vue&type=style&index=6&id=ff596cb6&prod&lang=scss"
import style7 from "./NewTemplate.vue?vue&type=style&index=7&id=ff596cb6&prod&lang=scss&scoped=true"
import style8 from "./NewTemplate.vue?vue&type=style&index=8&id=ff596cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff596cb6",
  null
  
)

export default component.exports